import React from 'react';
import { CheckboxProps } from '../../models';
import styles from './checkbox.module.scss';
import IconsColor from '../../util/iconsColor';

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  error,
  name,
  id,
  required = false,
  size = 'medium',
}) => {
  const checkboxId = id || `checkbox-${label?.toLowerCase().replace(/\s+/g, '-') + '-' + (new Date().getTime() * Math.random()).toString(36).substr(2, 9)}`;

  const handleChange = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleChange();
    }
  };

  return (
    <div className={`${styles.checkboxWrapper} ${styles[size]}`}>
      <div className={styles.checkboxContainer}>
        <div
          className={`${styles.checkboxBox} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''} ${error ? styles.error : ''}`}
          onClick={handleChange}
          onKeyDown={handleKeyDown}
          tabIndex={disabled ? -1 : 0}
          role="checkbox"
          aria-checked={checked}
          aria-disabled={disabled}
          aria-label={label || 'checkbox'}
        >
          {checked && (
            <div className={styles.checkboxIcon}>
              <IconsColor iconName="checkIcon" width="16px" height="16px" fillColor="none" strokeColor="currentColor" />
            </div>
          )}
        </div>

        {/* Hidden native input for form submission */}
        <input
          type="checkbox"
          id={checkboxId}
          name={name || checkboxId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          className={styles.checkboxInputHidden}
          tabIndex={-1}
          aria-hidden="true"
        />

        {label && (
          <label
            htmlFor={checkboxId}
            className={`${styles.checkboxLabel} ${disabled ? styles.disabled : ''}`}
            // onClick={handleChange}
          >
            {label}
            {required && <span className={styles.requiredIndicator}>*</span>}
          </label>
        )}
      </div>

      {error && (
        <span className={`${styles.messageText} ${styles.errorMessage}`}>
          <IconsColor iconName="errorIcon" width="16px" height="16px" fillColor="none" strokeColor="currentColor" />
          {error}
        </span>
      )}
    </div>
  );
};

export default Checkbox;

